import "../styles/Theme.css"
import { StartSettings } from "@pdfking/pdfview"
import { hydrate, render } from "preact"

import { Router } from "../router"

const root = document.getElementById("root")!

// A hash route (the viewer) is never prerendered: what's in #root is another
// page's html — cleared, since render would reuse those nodes as its own — so
// it renders from scratch, on the real settings from the start. A
// prerendered page was made on the defaults: it hydrates on those, then
// switches.
if (location.hash.startsWith("#/")) {
  StartSettings()
  root.replaceChildren()
  render(<Router name="home" />, root)
} else {
  hydrate(<Router name="home" />, root)
  StartSettings()
}
